import { render, staticRenderFns } from "./Accountview.vue?vue&type=template&id=5f32d952&scoped=true"
import script from "./Accountview.vue?vue&type=script&lang=js"
export * from "./Accountview.vue?vue&type=script&lang=js"
import style0 from "./Accountview.vue?vue&type=style&index=0&id=5f32d952&prod&lang=css"
import style1 from "./Accountview.vue?vue&type=style&index=1&id=5f32d952&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f32d952",
  null
  
)

export default component.exports